module.exports = __webpack_public_path__ + "static/media/heroes-doctor.826f27a6.png";